export default "/images/home.svg?f981ee9d6dcfecf8c081d9efc60e5d95";